import { AfterViewInit, Component, OnDestroy, ViewChild, } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MSMEGrievanceDashboard } from '../../../../../shared/models/MSMEGrievanceDashboard';
import { ToastrService } from 'ngx-toastr';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-grievancedashboard',
  templateUrl: './grievancedashboard.component.html',
  styleUrl: './grievancedashboard.component.css'
})
export class GrievancedashboardComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<MSMEGrievanceDashboard>
  displayedColumns: string[] = ['Sr.No', 'MSMEGrievanceId', 'Subject', 'Description', 'CreatedDate', 'Status', 'Download', 'Action']
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  msMeUserName = sessionStorage.getItem('userId');

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  DtoPagination =
    {
      "MSMEId":this.msMeUserName,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol":""
    }
    
  totalGrievances = 0;
  disposedGrievances = 0;
  pendingGrievances = 0;
  rejectedGrievances = 0;
  participantsAttended = 0;

  constructor(    
    private apiService: ApiService, private router: Router, public commonService: CommonService, private toastrService: ToastrService,
    public dialog: MatDialog) { }

  form = new FormGroup({
    searchControl: new FormControl('', [
      Validators.pattern(this.commonService.searchFilter)
    ])
  })

  async ngOnInit(): Promise<void> {
    this.GetEventCounts();
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchCol = this.commonService.searchText;
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETSUBMITTEDMSMEGRIEVANCEDETAILS, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  //loadData() {
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        //this.DtoPagination.SearchTerm = (searchTerm && typeof searchTerm == 'string') ? searchTerm.toString() : '';
  //        this.DtoPagination.SearchCol = this.commonService.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETSUBMITTEDMSMEGRIEVANCEDETAILS, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp.status) {
  //          this.length = resp['totalRecords'];
  //        } 
  //        return resp.data;
  //      })
  //    ).subscribe(data => {
  //      this.dataSource = data;
  //      this.adjustPaginator();
  //    });
  //}

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;

    this.loadData();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form.get('searchControl');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.loadData();
    }
  }
  
  AddNewGrievance() {
    this.router.navigate(['/submitgrievance']);
  }

  ViewGrievance(grId: string) {
    sessionStorage.setItem("GrievanceId", grId);
    this.router.navigate(['/viewgrievancereply']);
  }    
  
  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.loadData();
  }

  GetEventCounts() {
    let Id: string = sessionStorage.getItem('userId')!;
    let MSMEId: number = parseInt(Id, 10);
    this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEDASHBOARDCOUNTS, { MSMEId })
      .subscribe((result) => {
        if (result.status) {
          this.totalGrievances = result.data.totalGrievances;
          this.disposedGrievances = result.data.disposedGrievances;
          this.pendingGrievances = result.data.pendingGrievances;
          this.rejectedGrievances = result.data.rejectedGrievances;
          this.participantsAttended = result.data.participantsAttended;
        }
      });
  }

  CardRedirection(event: any) {
    const buttonId = (event.currentTarget as HTMLElement).id;
    switch (buttonId) {
      case 'btnTotalGrievances':
        this.commonService.searchText = '';
        this.loadData();
        break;
      case 'btnDisposedGrievances':
        this.commonService.searchText = 'Disposed';
        this.loadData();
        break;
      case 'btnPendingGrievances': 
        this.commonService.searchText = 'Pending';
        this.loadData();
        break;
      case 'btnRejectedGrievances':
        this.commonService.searchText = 'Rejected';
        this.loadData();
        break;
      default:
        window.location.reload();
        break;
    }
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  openFilePreviewDialog(filePath: string, fileName: string): void {
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }


  exportToExcel(): void {
    const fileName = 'Grievance_List.xlsx';

    const DtoPagination = {
      MSMEId: sessionStorage.getItem('userId'),
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: this.sort.active,
      SortDirection: this.sort.direction,
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETSUBMITTEDMSMEGRIEVANCEDETAILS, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastrService.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.rowNum,
            'Grievance ID': item.msmeGrievanceId,
            'Subject': "'" + item.subject + "'",
            'Description': "'" + item.description + "'",
            'Grievance Date': item.createdDate,
            'Status': item.status,
            'Download': item.documentPath ? 'Available' : 'Not Available',
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            { wch: 15 }, // Grievance ID
            { wch: 30 }, // Subject
            { wch: 50 }, // Description
            { wch: 20 }, // Grievance Date
            { wch: 15 }, // Status
            { wch: 20 }, // Download Status
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Grievance List': worksheet },
            SheetNames: ['Grievance List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastrService.success('Excel exported successfully!');
        }
      }
    );
  }




  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }


}

